import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import { uuidv4 } from "../../common";
function generateStyles(count, maxWidth, color, pos, zIndex = 9999) {
    const csses = [];
    for (let i = 1; i <= count; i++) {
        const percent = 1 - (i - 1) / (count - 1);
        const css = {
            transformOrigin: "center",
            position: "absolute",
            top: pos.x,
            left: pos.y,
            width: maxWidth * percent,
            height: maxWidth * percent,
            borderRadius: "50%",
            opacity: percent / 3 + 0.1,
            backgroundColor: color,
            transform: "translate(-50%,-50%)",
            transition: `${0.6 * (1 - percent)}s cubic-bezier(0.00, 0.00, 0.70, 1.00)`,
            zIndex: zIndex,
        };
        csses.push(css);
    }
    return csses;
}
export default function HoverCursor(props) {
    const csses = useRef([]);
    const uuid = useRef(uuidv4());
    // const clrcleRefs = useRef([] as React.MutableRefObject<any>[]);
    useEffect(() => {
        csses.current = generateStyles(props.numTrackers, props.width, props.color, { x: props.x, y: props.y }, props.zIndex);
    }, []);
    useEffect(() => {
        circles.map((css, index) => {
            const id = `${uuid.current}_${index}`;
            const el = document.getElementById(id);
            if (el) {
                el.style.left = props.x + "px";
                el.style.top = props.y + "px";
            }
        });
    }, [props.x, props.y]);
    useEffect(() => {
        circles.map((css, index) => {
            const id = `${uuid.current}_${index}`;
            const el = document.getElementById(id);
            if (el) {
                if (index < props.numFollowings) {
                    el.style.backgroundColor = props.color;
                }
                else {
                    el.style.backgroundColor = "rgba(0,0,0,0)";
                }
            }
        });
    }, [props.color, props.numFollowings]);
    const circles = csses.current;
    // const a = [1, 2, 3, 4];
    return (_jsx(React.Fragment, { children: circles.map((css, index) => {
            if (index < props.numFollowings)
                return (_jsx("div", { id: `${uuid.current}_${index}`, style: css }, index));
            return "";
        }) }));
}
//# sourceMappingURL=HoverCursor.js.map